import React, { useState, useEffect } from 'react';
import API from '../utils/gasClient';
import { Loading } from '../components/Loading';
import { CheckoutPage } from './CheckoutPage';

export const CheckoutPageContainer = ({ 
  event,
  pedido,
  setPedido,
  onNavigate,
  onVoltar
}) => {
  const [lotes, setLotes] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchLotes = async () => {
      try {
        setLoading(true);
        const lotesData = await API.getSpreadsheetData('lotes', event?.eventId);
        
        // Ordena os lotes por data de fim
        const lotesOrdenados = lotesData.sort((a, b) => {
          return new Date(a.dataFim) - new Date(b.dataFim);
        });

        setLotes(lotesOrdenados);
        
        // Inicializa participantes se não existir
        if (!pedido.participantes || pedido.participantes.length === 0) {
          const participantes = [];
          
          Object.entries(pedido.ingressos || {}).forEach(([nomeLote, quantidade]) => {
            for (let i = 0; i < quantidade; i++) {
              participantes.push({
                tipo: nomeLote,
                nome: '',
                unidade: ''
              });
            }
          });
          
          setPedido({
            ...pedido,
            participantes
          });
        }
        
        setLoading(false);
      } catch (err) {
        console.error('❌ Erro ao buscar lotes:', err);
        setLoading(false);
      }
    };

    if (event?.eventId) {
      fetchLotes();
    }
  }, [event]);

  const handleUpdateBuyer = (updatedPedido) => {
    setPedido(updatedPedido);
  };


  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  
  return (
    <CheckoutPage
      event={event}
      pedido={pedido}
      onUpdateBuyer={handleUpdateBuyer}
      onNavigate={onNavigate}
      lotes={lotes}
    />
  );
};
